<template>
  <div id="app" class="page-wrapper">
    <Header/>
    <div class="content">
      <router-view/>
    </div>
    <Footer/>
    <div id="blueimp-gallery" class="blueimp-gallery blueimp-gallery-controls">
      <div class="slides"></div>
      <h3 class="title"></h3>
      <a class="prev">‹</a>
      <a class="next">›</a>
      <a class="close">×</a>
      <a class="play-pause"></a>
      <ol class="indicator"></ol>
    </div>
    <modal name="modal-3d" :id="'modal-3d'" :width="960" :height="700" :clickToClose="true">
      <button @click="closeModal('modal-3d')" class="btn btn-link btn-close"><i class="fa fa-times"></i></button>
      <iframe src="https://old.oxynov.fr/devis" frameborder="0" scrolling="no" height="700" width="960"></iframe>
    </modal>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { EventBus } from '@/event-bus.js'

export default {
  name: 'App',
  components: {
    Header, Footer
  },
  methods: {
    openModal (name) {
      this.$modal.show(name)
    },
    closeModal (name) {
      this.$modal.hide(name)
    },
    openLink (url) {
      window.open(url, '_blank')
      this.closeModal('modal-welcome')
    }
  },
  mounted () {
    EventBus.$on('open-modal', name => {
      this.openModal(name)
    })
  }
}
</script>

<style>
  @import url('./assets/css/bootstrap.min.css');
  @import url('./assets/css/font-awesome.min.css');
  @import url('./assets/css/flaticon.css');
  @import url('./assets/css/app.css');
</style>

<style scoped>
#modal-3d .btn-close {
  position: absolute;
  right: 10px;
  top: 8px;
  color: #fff;
  font-size: 25px;
}
#modal-3d .btn-close:focus {
  outline: none;
}
</style>

<style>
@media only screen and (max-width : 480px) {
  .v--modal-overlay .v--modal-box {
    width: 95%!important;
    left: 2.5%!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue